<template>
	<div class="base_scroll_page" v-loading="loading">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增类型</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="id"
						label="ID"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						prop="typeLabel"
						label="类型"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination 
						layout="total, prev, pager, next, jumper" 
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange"
					>
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增分类 -->
		<add 
			v-model="add_display" 
			@onSuccess="addSuccess"
		></add>
		<!-- 新增分类 end -->
		
		<!-- 修改分类 -->
		<update 
			v-model="update_display"
			:obj="update_data"
			@onSuccess="updateSuccess"
		></update>
		<!-- 修改分类 end -->
	</div>
</template>

<script>
	import Add from './components/add.vue';
	import Update from './components/update.vue';
	import Api from '../../../../../api/index.js';
	import BaseMethods from '../../../../../assets/js/base.js';
	
	export default{
		mounted() {
			this.getData();
		},
		data() {
			return{
				loading: false,
				tableData: [],
				total: 0,
				currentPage: 1,
				
				add_display: false,
				
				update_display: false,
				update_data: {}
			}
		},
		methods: {
			/******************** @Events *************************/
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getData();
				}
			},
			// 点击新增
			handleAddClick() {
				this.add_display = true;
			},
			// 点击修改
			handleUpdateClick(data) {
				this.update_data = {...data};
				this.update_display = true;
			},
			// 点击删除
			handleDeleteClick(msg) {
				const that = this;
				that.$confirm(
					'此操作将删除该分类，是否继续?', 
					'提示', 
					{
						type: 'warning'
					}
				).then(
					() => {
						that.deleteSort(msg.id);
					}
				).catch(
					() => {}
				);
			},
			
			/******************** @Function *************************/
			// 获取数据
			getData() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: 10
				};
				Api.findIAssistantSortByPage(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.id,
								name: v.catName,
								typeId: v.catType,
								typeLabel: BaseMethods.mapIAssistantSortIdToLabel(v.catType),
								time: v.createTs
							});
						});
						that.total = res.data.data.total;
						that.tableData = list;
						that.loading = false;
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增成功
			addSuccess() {
				this.getData();
			},
			// 修改成功
			updateSuccess() {
				this.getData();
			},
			// 删除分类
			deleteSort(id) {
				const that = this;
				that.loading = true;
				Api.deleteIAssistantSort(id).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.getData();
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		components: {
			Add,
			Update
		}
	}
</script>

<style scoped>
</style>
